import { render, staticRenderFns } from "./SubTypeTicket.vue?vue&type=template&id=25c538eb&scoped=true"
import script from "./SubTypeTicket.vue?vue&type=script&lang=js"
export * from "./SubTypeTicket.vue?vue&type=script&lang=js"
import style0 from "./SubTypeTicket.vue?vue&type=style&index=0&id=25c538eb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c538eb",
  null
  
)

export default component.exports